/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2022, Zumper
 */

export const SET_LOCATION_URL = '@@nzr/forYou/SET_LOCATION_URL'
export const RECEIVE_LOCATION = '@@nzr/forYou/RECEIVE_LOCATION'
export const RECEIVE_PRICE_DATA = '@@nzr/forYou/RECEIVE_PRICE_DATA'
export const RECEIVE_LISTINGS = '@@nzr/forYou/RECEIVE_LISTINGS'
export const RECEIVE_REC_ENGINE_LISTINGS = '@@nzr/forYou/RECEIVE_REC_ENGINE_LISTINGS'
export const RECEIVE_SCORES = '@@nzr/forYou/RECEIVE_SCORES'
export const RECEIVE_REC_ENGINE_SCORES = '@@nzr/forYou/RECEIVE_REC_ENGINE_SCORES'
export const SET_LISTINGS_FETCHING = '@@nzr/forYou/SET_LISTINGS_FETCHING'
export const SET_REC_ENGINE_LISTINGS_FETCHING = '@@nzr/forYou/SET_REC_ENGINE_LISTINGS_FETCHING'
export const RECEIVE_NEARBY_HOODS = '@@nzr/forYou/RECEIVE_NEARBY_HOODS'
export const SET_NEARBY_HOODS_FETCHING = '@@nzr/forYou/SET_NEARBY_HOODS_FETCHING'
export const RECEIVE_TOP_NEARBY_HOODS = '@@nzr/forYou/RECEIVE_TOP_NEARBY_HOODS'
